import { gql } from "../../../../../gql/__generated__/gql";

export const CREATE_COLLAB = gql(`
  mutation createCollab($input: CreateCollabInput!) {
    createCollab(input: $input)
  }
`);

export const ACCEPT_COLLAB = gql(`
  mutation acceptCollab($collabId: String!) {
    acceptCollab(collabId: $collabId)
  }
`);

export const DECLINE_COLLAB = gql(`
  mutation declineCollab($collabId: String!) {
    declineCollab(collabId: $collabId)
  }
`);

export const CHANGE_COLLAB_OFFER = gql(`
  mutation changeCollabOffer($input: ChangeCollabOfferInput!) {
    changeCollabOffer(input: $input)
  }
`);

export const SUBMIT_COLLAB_CONTENT = gql(`
  mutation submitCollabContent($input: SubmitCollabContentInput!) {
    submitCollabContent(input: $input)
  }
`);

export const ACCEPT_COLLAB_CONTENT = gql(`
  mutation acceptCollabContent($collabId: String!, $contentId: String!) {
    acceptCollabContent(collabId: $collabId, contentId: $contentId){
      isAllContentApproved
    }
  }
`);

export const REQUEST_COLLAB_CHANGES = gql(`
  mutation requestCollabChanges($collabId: String!, $message: String) {
    requestCollabChanges(collabId: $collabId, message: $message)
  }
`);

export const REQUEST_CONTENT_CHANGES = gql(`
  mutation requestContentChanges($collabId: String!, $contentId: String!, $feedbackMessage: String!) {
    requestContentChanges(collabId: $collabId, contentId: $contentId, feedbackMessage: $feedbackMessage)
  }
`);

export const REPLACE_CONTENT_ITEM = gql(`
  mutation replaceContentItem($collabId: String!, $contentId: String!, $newContentUrl: String!, $newContentType: String) {
    replaceContentItem(collabId: $collabId, contentId: $contentId, newContentUrl: $newContentUrl, newContentType: $newContentType)
  }
`);
